import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppFloat from "./WhatsAppFloat";

export default function Layout({ children }) {
  return (
    <div className="grain min-h-screen bg-[#0A0A0A] text-[#F5F5DC]">
      <Navbar />
      <main className="pt-[140px] lg:pt-[150px]">{children}</main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
